import {Injectable} from '@angular/core';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';
import {NgOpenCVService, OpenCVLoadResult} from 'ng-open-cv';
import {filter, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OpencvService {
  // Notifies of the ready state of the classifiers load operation
  private classifiersLoaded = new BehaviorSubject<boolean>(false);
  public started?: boolean;
  public fps = 30;
  public classifiersLoadFinished: boolean;
  public onLoadedClassifiers: any;
  public currentClassifier = 'haarcascade_eye.xml';
  private srcElement: any;
  private dstElement: any;

  constructor(private ngOpenCVService: NgOpenCVService) {
    this.prepareOpenCV();
    this.classifiersLoadFinished = false;
  }

  public setVariables(srcElement: any, dstElement: any) {
    this.srcElement = srcElement;
    this.dstElement = dstElement;
  }

  public prepareOpenCV() {
    this.ngOpenCVService.isReady$
      .pipe(
        // The OpenCV library has been successfully loaded if result.ready === true
        filter((result: OpenCVLoadResult) => result.ready),
        switchMap(() => {
          // Load the face and eye classifiers files
          console.log('Load the face and eye classifiers files');
          return this.loadClassifiers();
        })
      )
      .subscribe(() => {
        // The classifiers have been succesfully loaded
        console.log(' The classifiers have been succesfully loaded');
        this.classifiersLoaded.next(true);
        this.classifiersLoadFinished = true;
        setTimeout(() => {
          if (this.onLoadedClassifiers) {
            this.onLoadedClassifiers();
          }
        }, 1000);
      });
  }

  loadClassifiers(): Observable<any> {
    return forkJoin(
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_smile.xml',
        `assets/opencv/data/haarcascades/haarcascade_smile.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_eye.xml',
        `assets/opencv/data/haarcascades/haarcascade_eye.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_fullbody.xml',
        `assets/opencv/data/haarcascades/haarcascade_fullbody.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_upperbody.xml',
        `assets/opencv/data/haarcascades/haarcascade_upperbody.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_profileface.xml',
        `assets/opencv/data/haarcascades/haarcascade_profileface.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_eye_tree_eyeglasses.xml',
        `assets/opencv/data/haarcascades/haarcascade_eye_tree_eyeglasses.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_frontalface_alt2.xml',
        `assets/opencv/data/haarcascades/haarcascade_frontalface_alt2.xml`
      ),
      this.ngOpenCVService.createFileFromUrl(
        'haarcascade_lowerbody.xml',
        `assets/opencv/data/haarcascades/haarcascade_lowerbody.xml`
      )
    );
  }

  // Video detection
  videoDetection() {

    this.started = true;
    const video = this.srcElement;
    video.height = 480;
    video.width = 640;
    this.dstElement.height = video.height;
    this.dstElement.width = video.width;

    const src = new cv.Mat(video.height, video.width, cv.CV_8UC4);
    const dst = new cv.Mat(video.height, video.height, cv.CV_8UC4);
    const gray = new cv.Mat();
    const cap = new cv.VideoCapture(video);
    const detectedItems = new cv.RectVector();
    const classifier = new cv.CascadeClassifier();
    // load pre-trained classifiers
    classifier.load(this.currentClassifier);

    const myRecursionFunc = (delay: number) => {
      setTimeout(() => {
        try {
          if (!this.started) {
            // clean and stop.
            src.delete();
            dst.delete();
            gray.delete();
            detectedItems.delete();
            classifier.delete();
            return;
          }
          const begin = Date.now();
          cap.read(src);
          src.copyTo(dst);
          cv.cvtColor(dst, gray, cv.COLOR_RGBA2GRAY, 0);
          classifier.detectMultiScale(gray, detectedItems, 1.3, 5, 0);
          for (let i = 0; i < detectedItems.size(); i++) {
            const face = detectedItems.get(i);
            const point1 = new cv.Point(face.x, face.y);
            const point2 = new cv.Point(face.x + face.width, face.y + face.height);
            cv.rectangle(dst, point1, point2, [255, 0, 0, 255]);
            if (this.currentClassifier === 'haarcascade_smile.xml') {
              break;
            }
          }
          cv.imshow(this.dstElement, dst);
          delay = 1000 / this.fps; // - (Date.now() - begin);
          myRecursionFunc(delay);
        } catch (err) {
          console.log(err);
        }
      }, delay);
    };

    myRecursionFunc(0);
  }

  stopVideoDetection() {
    this.started = false;
  }
}
